<template lang="pug">
	.folders-list(v-if="showed", :style="{'height': height + 'px','left': leftX + 'px', 'top': topY + 'px'}" @mouseout="hideFolders()")
		.folder-wrapper(v-if="Project.SelectedProject && Project.SelectedProject.folder_id" @click="moveToFolder(null)")
			i.fa.fa-folder
			.folder-title-wrapper
				.folder-title None
		.folder-wrapper(v-for="folder of folders" @click="moveToFolder(folder.id)")
			i.fa.fa-folder
			.folder-title-wrapper
				.folder-title {{folder.title}}

</template>

<script>

	import Screen 				from './../../mixins/screen';

	import { User } 			from './../../services/User';
	import { Template } 		from './../../services/Template';
	import { Monitoring } 		from './../../services/Monitoring';
	import { Project } 			from './../../services/Project';

	export default {
		name: "ProjectActionsShowFolders",
		mixins: [Screen],
		screen: {
			updateOn: ["Current User Changed", "Folder Changed", "Selected Folder Changed"],
			events: {
				"Monitoring Channel Updated": function() {
					this.update();
				},
				"Show Project Actions Show Folders": function (...params) {
					let x = params[0];
					let y = params[1];
					if (Template.SelectedTemplate) {
						let templateId = Template.SelectedTemplate.id;

						let folders = this.folders = Project.getFoldersByTemplate(templateId);

						console.log(Project.SelectedProject.folder_id);

						let foldersCount = Project.SelectedProject && Project.SelectedProject.folder_id === null ? folders.length : folders.length + 1;

						this.height = foldersCount < 5 ? foldersCount * 48 : 5 * 48;
					}

					let newY = y - this.height / 2;
					if (newY + this.height + 25 > window.innerHeight) newY = window.innerHeight - this.height - 25;

					this.setPos(x, newY);

				}
			}
		},
		props: ['index'],
		data() {

			this.Project = Project;
			this.User = User;
			this.Template = Template;
			this.Monitoring = Monitoring;

			this.topY = 0;
			this.leftX = 0;
			this.height = 0;

			this.folders = {};

			this.copyState = {
				copy: true,
				paste: false,
				title: null
			};

			return {
				showed: true
			};

		},
		methods: {

			collectData() {

			},

			setPos(x, y) {
				this.leftX = x;
				this.topY = y;
				this.$forceUpdate();
			},

			moveToFolder(id) {
				Project.moveToFolder(id);
				this.hide();
			},

			hideFolders() {
				let hide = true;
				let elements = document.querySelectorAll(':hover');
				for (let i = 0; i < elements.length; i++) {
					if (elements[i].classList.contains('folders-list')) {
						hide = false;
						break;
					}
				}
				if (hide) this.hide();
			}
		}
	}
</script>


<style lang="sass" scoped>

	.folders-list
		position: absolute
		width: 200px
		height: 200px
		box-shadow: 0 0 10px rgba(0, 0, 0, 0.5)
		z-index: 9999999
		display: flex
		flex-direction: column
		overflow-x: hidden
		overflow-y: auto
		background-color: #3a4149
		color: #23282c

		&::-webkit-scrollbar
			position: fixed
			width: 10px
			margin-left: -10px
			-webkit-appearance: none
			appearance: none

		&::-webkit-scrollbar-thumb
			height: 50px
			background-color: rgba(0, 0, 0, 0.2)
			background-clip: content-box
			border-color: transparent
			border-radius: 5px

		.folder-wrapper
			border: #09191c 0.5px solid
			background-color: #3a4149
			color: white
			box-sizing: border-box
			-moz-box-sizing: border-box
			-webkit-box-sizing: border-box
			min-height: 48px
			max-height: 48px
			display: flex
			cursor: pointer

			&:hover
				background-color: #292b2d

			.fa
				pointer-events: none
				margin: auto 0
				padding: 0 0.25rem 0 1rem

			.folder-title-wrapper
				display: flex
				align-items: center
				width: 100%
				pointer-events: none



</style>

